import POST_COMPONENT_TYPE from '../postComponentType';
import hypothyroidismHero from '../../../assets/images/hypothyriodism-hero-section.png';
import { TextBoxBackgroundColor } from '../../../components/BannerWithTextBox';
import { IconType } from '../../../components/BannerWithList';

const hypothyroidismData = {
  key: 'hypothyroidism',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.hypothyroidism.name'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: hypothyroidismHero,
      text: 'learnMoreContent.hypothyroidism.banner.text',
      backgroundColor: TextBoxBackgroundColor.RED
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.hypothyroidism.explained.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.hypothyroidism.explained.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.hypothyroidism.explained.listItem2',
              type: 'text'
            },
            {
              text: 'learnMoreContent.hypothyroidism.explained.listItem3',
              type: 'text',
              subItems: [
                {
                  text:
                    'learnMoreContent.hypothyroidism.explained.listItem3.subItem1',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.hypothyroidism.explained.listItem3.subItem2',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.hypothyroidism.explained.listItem3.subItem3',
                  type: 'text'
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.hypothyroidism.overweight.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.hypothyroidism.overweight.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.hypothyroidism.overweight.listItem2',
              type: 'text'
            },
            {
              text: 'learnMoreContent.hypothyroidism.overweight.listItem3',
              type: 'text'
            },
            {
              text: 'learnMoreContent.hypothyroidism.overweight.listItem4',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.hypothyroidism.measured.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title: 'learnMoreContent.hypothyroidism.measured.listGroup1.title',
          items: [
            {
              text:
                'learnMoreContent.hypothyroidism.measured.listGroup1.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.hypothyroidism.measured.listGroup1.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.hypothyroidism.measured.listGroup1.listItem3',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.hypothyroidism.measured.listGroup1.listItem4',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.hypothyroidism.treatment.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.hypothyroidism.treatment.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.hypothyroidism.treatment.listItem2',
              type: 'text'
            },
            {
              text: 'learnMoreContent.hypothyroidism.treatment.listItem3',
              type: 'text'
            },
            {
              text: 'learnMoreContent.hypothyroidism.treatment.listItem4',
              type: 'text'
            }
          ]
        }
      ]
    }
  ]
};

export default hypothyroidismData;